module.exports = __webpack_public_path__ + "static/img/jcsp.392157b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/jcsp.webp
// module id = ca+2
// module chunks = 68